import moment from 'moment';

const timeRestriction = {
  standard: 60
};

export const isJourneyTimeRestricted = ({ outboundDate, outboundArrives, inboundDate, inboundDeparts }) => {
  if (!outboundArrives || !inboundDeparts) {
    return false;
  }

  const outboundArrivalDate = moment(`${outboundDate} ${outboundArrives}`, 'YYYY-MM-DD HH:mm');
  const inboundDepartureDate = moment(`${inboundDate} ${inboundDeparts}`, 'YYYY-MM-DD HH:mm');

  return inboundDepartureDate.diff(outboundArrivalDate, 'minutes') < timeRestriction.standard;
};
